import { useLocation, useNavigate } from "react-router-dom";
import { lenisRef } from "@/lib/lenis";

const items = ["'JESTER' HOODIE DROPPING SOON", "Sviin"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((t, i) => (
      <span key={i} className={`label flex items-center gap-8 px-8 text-[#F4F2EE] ${t === "Sviin" ? "normal-case" : ""}`}>
        {t}
        <span className="inline-block h-1 w-1 bg-[#F4F2EE]" />
      </span>
    ))}
  </div>
);

export const scrollToJester = () => {
  const el = document.getElementById("jester");
  if (!el) return false;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
  return true;
};

export const AnnouncementBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = () => {
    if (pathname === "/" && scrollToJester()) return;
    navigate("/");
    let tries = 0;
    const t = setInterval(() => {
      if (scrollToJester() || ++tries > 20) {
        clearInterval(t);
        setTimeout(scrollToJester, 900);
      }
    }, 150);
  };
  return (
    <button
      type="button"
      onClick={go}
      data-testid="announcement-marquee"
      aria-label="'Jester' hoodie dropping soon — see the Jester"
      className="relative z-50 block h-9 w-full overflow-hidden bg-[#111111] transition-colors duration-300 hover:bg-[#1d1d1d]"
    >
      <div className="marquee-track flex h-full w-max items-center">
        <Row /><Row hidden /><Row hidden /><Row hidden /><Row hidden /><Row hidden /><Row hidden /><Row hidden />
      </div>
    </button>
  );
};
